interface MachineStatsProps {
  stats: { value: string; label: string }[];
}

export function MachineStats({ stats }: MachineStatsProps) {
  return (
    <section className="py-16 bg-secondary/30">
      <div className="container mx-auto px-4 sm:px-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 sm:gap-6 text-center">
          {stats.map((stat) => (
            <div key={stat.label} className="stat-card">
              <div className="text-3xl font-bold font-mono text-primary">{stat.value}</div>
              <div className="mt-2 text-sm text-muted-foreground">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
